import React, {useState} from "react";
import {Box, Stack} from "@mui/material";
import importedStyles from "../Utilities/styles";
import PageContainer from "../../../common/PageContainer";
import AnchorButton from "../../../common/AnchorButton";
import TemplatesTable from "../Utilities/TemplatesTable";
import _ from "lodash";
import {queryStringToObject} from "../../../../../_helpers";
import OrganizationFilter from "../../../common/OrganizationFilter";

export default function AdminTemplate() {
    const search = window.location.search.substring(1);
    const urlParams =  queryStringToObject(search);

    const [organizationId, setOrganizationId] = useState(()=> _.get(urlParams, 'organizationId') || "");

    return(
        <PageContainer backgroundColor={'#EFEAE7'} size="large">
            <Stack direction={{ xs: 'column', md: 'row' }} sx={styles.hero} spacing={2}>
                <Box component={'h1'} sx={importedStyles.headingLarge}>
                    List of templates
                </Box>
                <Box sx={styles.formContainer}>
                    <OrganizationFilter urlParams={urlParams} setOrganizationId={setOrganizationId}/>
                    <AnchorButton label={'Create new template'} link={'/admin/create-template'}/>
                </Box>
            </Stack>

            <Box>
                <TemplatesTable organizationId={organizationId}/>
            </Box>
        </PageContainer>
    )
}

const styles = {
    hero: {
        justifyContent: 'space-between',
        alignItems: { xs: 'flex-start', md: 'center' },
        mb: { xs: '24px', sm: '40px', },
    },
    formContainer: {
        width: { xs: '100%', sm: 'auto' ,height: '40px'},
        display: 'flex',
        gap: 2
    }
}